<template>
  <v-data-table
    v-if="hasAccess"
    :headers="headers"
    :items="data"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
            class="table__top-header"
          >
            <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.form.configure.title') }}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
          </v-col>
          <v-col
            cols="12"
            sm="8"
            md="8"
            class="table__top-tools"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$vuetify.lang.t('$vuetify.search')"
              single-line
              hide-details
              style="max-width: 250px;"
            />
            <v-dialog
              v-model="deleteDialog"
              persistent
            >
              <v-card>
                <v-card-title class="headline">
                  {{ $vuetify.lang.t('$vuetify.generalDeleteMessage') }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="deleteDialog = false"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="deleteAction"
                  >
                    {{ $vuetify.lang.t('$vuetify.delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog"
              persistent
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on"
                >
                  {{ $vuetify.lang.t('$vuetify.newItem') }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.name"
                          :label="$vuetify.lang.t('$vuetify.name')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                      >
                        <v-row>
                          <v-col cols="12">
                            <div class="headline text--primary mb-2">
                              {{ $vuetify.lang.t('$vuetify.form.configure.buttons') }}
                            </div>
                          </v-col>
                        </v-row>
                        <v-row
                          v-for="(item, index) in editedItem.buttons"
                          :key="index"
                          class="d-flex align-center"
                        >
                          <v-col cols="11">
                            <v-text-field
                              v-model="item.name"
                              :label="`${$vuetify.lang.t('$vuetify.form.configure.buttonName')} ${index + 1}`"
                            />
                          </v-col>
                          <v-col
                            cols="1"
                            class="d-flex justify-center"
                          >
                            <v-icon
                              small
                              @click="deleteButton(index)"
                            >
                              mdi-delete
                            </v-icon>
                          </v-col>
                        </v-row>
                        <v-btn
                          v-show="editedItem.buttons.length < maxButtonLimit"
                          color="primary"
                          @click="addButton"
                        >
                          {{ $vuetify.lang.t('$vuetify.form.addNew') }}
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="6"
                      >
                        <v-row>
                          <v-col cols="12">
                            <div class="headline text--primary mb-2">
                              {{ $vuetify.lang.t('$vuetify.form.configure.inputs') }}
                            </div>
                          </v-col>
                        </v-row>
                        <v-row
                          v-for="(item, index) in editedItem.inputs"
                          :key="index"
                          class="d-flex align-center"
                        >
                          <v-col cols="11">
                            <v-text-field
                              v-model="item.name"
                              :label="`${$vuetify.lang.t('$vuetify.form.configure.inputName')} ${index + 1}`"
                            />
                          </v-col>
                          <v-col
                            cols="1"
                            class="d-flex justify-center"
                          >
                            <v-icon
                              small
                              @click="deleteInput(index)"
                            >
                              mdi-delete
                            </v-icon>
                          </v-col>
                        </v-row>
                        <v-btn
                          v-show="editedItem.inputs.length < maxInputLimit"
                          color="primary"
                          @click="addInput"
                        >
                          {{ $vuetify.lang.t('$vuetify.form.addNew') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1" />
                  <v-btn
                    color="secondary"
                    text
                    @click="close"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="secondary"
                    text
                    @click="save"
                  >
                    {{ $vuetify.lang.t('$vuetify.save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        {{ $vuetify.lang.t('$vuetify.reset') }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import apiUtil from '../utils/ApiUtil';

export default {
  data: () => {
    return {
      permissionsKey: 2,
      maxButtonLimit: 50,
      maxInputLimit: 6,
      search: '',
      dialog: false,
      deleteDialog: false,
      deletedItem: {},
      data: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        buttons: [],
        inputs: [],
      },
      defaultItem: {
        name: '',
        buttons: [],
        inputs: [],
      },
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$vuetify.lang.t('$vuetify.newItem') : this.$vuetify.lang.t('$vuetify.editItem');
    },
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: this.$vuetify.lang.t('$vuetify.name'), value: 'name' },
        { text: this.$vuetify.lang.t('$vuetify.actions'), value: 'action', sortable: false },
      ];
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);
  },
  methods: {
    async initialize() {
      const result = await apiUtil.getAllForms();
      this.data = result;
    },
    editItem(item) {
      const itemCloned = Object.assign({}, item);
      this.editedItem = itemCloned;
      this.editedIndex = this.data.findIndex((i) => { return i.id === this.editedItem.id; });
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.deleteDialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async deleteAction() {
      const index = this.data.findIndex((i) => { return i.id === this.deletedItem.id; });
      const result = await apiUtil.deleteFormById(this.deletedItem);
      if (result) {
        this.data.splice(index, 1);
      }
      this.deleteDialog = false;
    },
    async save() {
      const response = await apiUtil.saveForm(this.editedItem);
      if (this.editedIndex > -1) {
        Object.assign(this.data[this.editedIndex], response);
      } else {
        this.data.push(response);
      }

      this.close();
    },
    addButton() {
      if (this.editedItem.buttons.length >= this.maxButtonLimit) {
        return;
      }

      this.editedItem.buttons.push({ name: '' });
    },
    deleteButton(index) {
      this.editedItem.buttons.splice(index, 1);
    },
    addInput() {
      if (this.editedItem.inputs.length >= this.maxInputLimit) {
        return;
      }

      this.editedItem.inputs.push({ name: '' });
    },
    deleteInput(index) {
      this.editedItem.inputs.splice(index, 1);
    },
  },
};
</script>
